import * as React from 'react';
import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { styled } from '../../../stitches.config';

export const SortableItem = (props: React.PropsWithChildren<{ id: string }>) => {
  const animateLayoutChanges: AnimateLayoutChanges = (args) =>
    defaultAnimateLayoutChanges({ ...args, wasDragging: true });

  const { attributes, setNodeRef, transform, transition } = useSortable({
    id: props.id,
    animateLayoutChanges,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <SortableItemWrapper ref={setNodeRef} style={style} {...attributes}>
      {props.children}
    </SortableItemWrapper>
  );
};

export const SortableHandle = (props: React.PropsWithChildren<{ id: string }>) => {
  const { listeners, setActivatorNodeRef } = useSortable({
    id: props.id,
  });

  return (
    <div ref={setActivatorNodeRef} {...listeners}>
      {props.children}
    </div>
  );
};

const SortableItemWrapper = styled('div', {
  '&:focus': {
    outline: 'none',
  },
});
